import React from 'react';
import ReactDOM from 'react-dom/client';
import './sprungkraft/index.css';
import App from './sprungkraft/App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
